import moment from "moment";
import React from "react";

const renderItem = ({ styles, item, index }) => {
  return (
    <div style={styles.containerColuna} key={index}>
      <div style={styles.colunaDescricao}>
        <div style={styles.text}>{item?.profissionalSaude?.nome || "-"}</div>
      </div>
      <div style={styles.colunaDescricao}>
        <div style={styles.text}>{item.quantidadeAgendamentos}</div>
      </div>
      <div style={styles.coluna}>
        <div style={styles.text}>{item.valorTotalAPagar}</div>
      </div>
      <div style={styles.coluna}>
        <div style={styles.text}>{item.totalAReceber}</div>
      </div>
    </div>
  );
};

const RelatorioRepasseSinteticoPdf = ({
  filter,
  repasses,
  tiposAtendimento,
}) => {
  const { dataInicial, dataFinal, profissionalSaude, convenio, tipo } = filter;

  const periodoData = `${moment(dataInicial).format("DD/MM/YYYY")} - ${moment(
    dataFinal
  ).format("DD/MM/YYYY")}`;

  const tipoAtendimento = tiposAtendimento.find((item) => (item.id === tipo));

  return (
    <>
      <div style={styles.titulo}>
        <div style={styles.textBold}>Relatório repasses Sintético</div>
      </div>
      <div style={styles.subTitulo}>
        <div style={styles.textBold}>Data: {periodoData}</div>
        <div style={styles.textBold}>
          Profissional: {profissionalSaude?.nome}
        </div>
        <div style={styles.textBold}>Convenio: {convenio?.descricao}</div>
        <div style={styles.textBold}>
          Tipo: {tipoAtendimento?.descricao || ""}
        </div>
      </div>

      <div style={styles.containerColuna}>
        <div style={styles.coluna}>
          <div style={styles.textBold}>Profissional</div>
        </div>
        <div style={styles.colunaDescricao}>
          <div style={styles.textBold}>Qtd. Agendamentos</div>
        </div>
        <div style={styles.coluna}>
          <div style={styles.textBold}>Total de valor a pagar</div>
        </div>
        <div style={styles.colunaDescricao}>
          <div style={styles.textBold}>Total de valor a receber</div>
        </div>
      </div>

      {repasses.map((item, index) => renderItem({ styles, item, index }))}
    </>
  );
};

const styles = {
  text: {
    fontSize: 12,
  },
  textBold: {
    fontSize: 12,
    fontWeight: 700,
    width: "100%",
  },
  titulo: {
    marginLeft: 0,
    marginBottom: 10,
    marginTop: 5,
    paddingBottom: 5,
    textAlign: "center",
  },
  subTitulo: {
    display: "flex",
    flexDirection: "row",
    borderBottom: "1px solid #505050",
    marginBottom: 15,
    paddingBottom: 5,
    justifyContent: "space-between",
  },
  containerColuna: {
    display: "flex",
    flexDirection: "row",
  },
  coluna: {
    width: "30%",
  },
  colunaDescricao: {
    display: "flex",
    marginBottom: "10px",
    marginRight: "3px",
    width: "30%",
  },
};

export default RelatorioRepasseSinteticoPdf;
